export const stringToSlug = (str: string) =>
  str?.toLowerCase().split(' ').join('-');

export const deunderscoreString = (str: string) => str.replace(/_/g, ' ');

export const toTitleCase = (str: string, separator = ' ') => {
  return str
    .split(separator)
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
    .join(separator);
};

export const truncateString = (str: string, maxCharLength: number) => {
  return str.length > maxCharLength
    ? str.slice(0, maxCharLength).concat('...')
    : str;
};

export const beautifyString = (str: string, shouldAddTitleCase = true) => {
  const formatted = str.replace(/[-_]/g, ' ');
  return shouldAddTitleCase ? toTitleCase(formatted) : formatted;
};

export const replaceEmojisWith = (str: string, replaceWith: string) => {
  return str.replace(
    /[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2580-\u27BF]|\uD83E[\uDD10-\uDDFF]/g,
    replaceWith,
  );
};
